import Mock from "mockjs";
import facilityAPI from "./facility";
import inspectAPI from "./inspect";
import loginAPI from "./login";
import issueAPI from "./issue";

// Fix an issue with setting withCredentials = true, cross-domain request lost cookies
// https://github.com/nuysoft/Mock/issues/300
Mock.XHR.prototype.proxy_send = Mock.XHR.prototype.send;
Mock.XHR.prototype.send = function() {
  if (this.custom.xhr) {
    this.custom.xhr.withCredentials = this.withCredentials || false;
  }
  this.proxy_send(...arguments);
};
// Mock.setup({
//   timeout: '350-600'
// })

// Mock.mock(/api-customer\/location\/facilitiesCount/, 'get', facilityAPI.getCount)
// Mock.mock(/api-customer\/location\/patrolTasks\/today/, 'get', inspectAPI.getInpsectList)
// Mock.mock(/api-customer\/location\/facility\/types/, 'get', facilityAPI.getTypes)
// Mock.mock(/api-customer\/location\/facilities\/type\/12\/gpsAreas/, 'get', facilityAPI.getAreas)
// Mock.mock(/api-customer\/civicism\/login/, 'post', loginAPI.getUserInfo)

// Mock.mock(/api-customer\/location\/issues\/search/, 'get', issueAPI.queryIssuesToHandle)
// TODO 添加code参数
// Mock.mock(/api-customer\/location\/issueClassifys/, 'get', issueAPI.queryIssueTypes)

// Mock.mock(/api-customer\/location\/issue\/report/, 'post', issueAPI.reportIssue)

// Mock.mock(/api-customer\/location\/issues\/among\/\d+/, 'get', issueAPI.issueDetail)
// Mock.mock(
//   /api-customer\/location\/patrolTasks\/today/,
//   "get",
//   inspectAPI.getInpsectList
// );

export default Mock;



// WEBPACK FOOTER //
// ./mock/index.js